import React, { useCallback } from "react"
import { State } from "@hookstate/core"
import { useLanguageState } from "../../globalStates/LanguageState"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import VideoReplacePicker from "../../components/VideoReplacePicker"
import { EventDate } from "../../globalStates/ExhibitorDataTypes"

interface PrerecordedContentsProps {
    eventDate: State<EventDate>
}

const PrerecordedContents: React.FC<PrerecordedContentsProps> = ({ eventDate }) => {
    const branding = useLanguageState().getStrings()
    const exiState = useExhibitorDataState()

    const onChangeVideo = useCallback(
        (
            image: File,
            onUploadProgress: (progress: number) => void,
            onSuccessCallback: () => void,
            onErrorCallback: (reason: string) => void
        ) => {
            exiState
                .upload("MULTIMEDIA", image, onUploadProgress)
                .then((response) => {
                    onSuccessCallback()
                    if (response) {
                        eventDate.liveStreamingPreviewFileID.set(response.fileId)
                        eventDate.liveStreamingPreviewUrl.set(response.fileUrl)
                    }
                })
                .catch((reason) => onErrorCallback(reason))
        },
        [exiState, eventDate]
    )

    return (
        <VideoReplacePicker
            placeholderTitle={branding.configuration.eventDatesPage.sctEventDates.hntDropzoneTitlePrerecorded}
            placeholderText={branding.configuration.eventDatesPage.sctEventDates.hntDropzonePropPrerecorded}
            value={eventDate.liveStreamingPreviewUrl.get()}
            onChangeVideo={onChangeVideo}
        />
    )
}

export default PrerecordedContents
